import { render } from "./app-format-date.vue?vue&type=template&id=5f556de6&ts=true"
import script from "./app-format-date.vue?vue&type=script&lang=ts"
export * from "./app-format-date.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__